export default __webpack_public_path__ + "maps-guides-view-annotation-z-index-960-8e96803949b13391c223a8fd86a60b21.webp";